import { render } from "./FullProcessRough.vue?vue&type=template&id=ab34aee0"
import script from "./FullProcessRough.vue?vue&type=script&lang=js"
export * from "./FullProcessRough.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__